import "./StaffCard.scss";
import facultyPlaceholderImg from "../../../src/assets/Images/FacultyPlaceholderImg.jpeg"

const StaffCard = ({ bgImage, facultyImages, staffName, education, designation, customStyles }) => {

    const resolvedImage = facultyImages[bgImage] || facultyPlaceholderImg;

    const defaultStyles = {
        marginBottom: "25px"
    }

    

    return (
        <div className="staffCardContainer" style={customStyles ? customStyles : defaultStyles}>
            <div
                className="staffCardImage"
                style={{ backgroundImage: `url(${resolvedImage})` }}
            >
            </div>
            <div className="staffCardContent">
                {staffName && (<h3 style={{ color: "black", fontSize: "clamp(1.2rem, 1.4vw, 1.5rem)" }}>{staffName}</h3>)}
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {education && (<h3 style={{ color: "black", fontSize: "clamp(1rem, 1.26vw, 1.35rem)" }}>{education}</h3>)}
                    {designation && (<h3 style={{ color: "black", fontSize: "clamp(1rem, 1.26vw, 1.35rem)" }}>{designation}</h3>)}
                </div>
            </div>
        </div>
    );
}

export default StaffCard;
